var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfos2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0713 4.92809C15.1656 1.02288 8.83319 1.02245 4.92711 4.92809C1.02147 8.83373 1.02191 15.1662 4.92711 19.0722C8.83276 22.977 15.1652 22.9774 19.0713 19.0722C22.9765 15.1662 22.976 8.83417 19.0713 4.92809Z",
    fill: "#666A6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5459V12.9092",
    stroke: "#EEFBF9",
    strokeWidth: 2.72754,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4006 7.90869C11.4006 7.5321 11.7059 7.22681 12.0825 7.22681C12.4591 7.22681 12.7644 7.5321 12.7644 7.90869C12.7644 8.28529 12.4591 8.59058 12.0825 8.59058C11.7059 8.59058 11.4006 8.28529 11.4006 7.90869Z",
    stroke: "#EEFBF9",
    strokeWidth: 1.36377
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfos2);
export default __webpack_public_path__ + "static/media/infos2.9bd0cbc24bda9ac0d72ff58b0131e69e.svg";
export { ForwardRef as ReactComponent };